import { Form, notification } from "antd";
import { useState, useEffect, useCallback } from "react";
import dayjs from "dayjs";
import _ from "lodash";
import $axios from "../services/axios";

export const useHistoryLogic = ({ setLoading }) => {
    const [form] = Form.useForm();
    const [listHistory, setListHistory] = useState([]);
    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const rangePresets = [
        { label: "7 ngày qua", value: [dayjs().add(-7, "d"), dayjs()] },
        { label: "14 ngày qua", value: [dayjs().add(-14, "d"), dayjs()] },
        { label: "30 ngày qua", value: [dayjs().add(-30, "d"), dayjs()] },
        { label: "90 ngày qua", value: [dayjs().add(-90, "d"), dayjs()] },
    ];

    const getListHistory = useCallback(async (page, dateRange) => {
        if (!dateRange || dateRange.length !== 2) return;

        const startTime = dayjs(dateRange[0]).format("DD/MM/YYYY");
        const endTime = dayjs(dateRange[1]).format("DD/MM/YYYY");
        setLoading(true);
        try {
            const res = await $axios.$get(
                `/v1/api/order-hotel/findByAllUser?startDate=${startTime}&endDate=${endTime}&page=${page}&pageSize=10`
            );
            setListHistory(res.data?.data?.data || []);
            setTotal(res.data?.data?.data?.totalRecordCount || 0);
            setCurrentPage(page);
        } catch (error) {
            notification.error({
                message: "Lỗi",
                description: "Không thể lấy thông tin lịch sử đặt phòng.",
            });
        } finally {
            setLoading(false);
        }
    }, [setLoading]);

    useEffect(() => {
        getListHistory(1, _.get(rangePresets, "[0].value", []));
    }, [getListHistory]);

    const onFinish = async (values) => {
        await getListHistory(1, values.dateRange);
    };

    return {
        form,
        listHistory,
        total,
        currentPage,
        rangePresets,
        getListHistory,
        onFinish
    };
};
